var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{attrs:{"items":_vm.providers,"label":"Provider *","item-text":"name","item-value":"name","dense":"","outlined":"","clearable":false,"disabled":""},model:{value:(_vm.providers[0]),callback:function ($$v) {_vm.$set(_vm.providers, 0, $$v)},expression:"providers[0]"}})
}
var staticRenderFns = []

export { render, staticRenderFns }